import Vue from "vue";
import Vuex from "vuex";
import { doc, getDoc } from "firebase/firestore"
import db from "@/db";

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        user: {
          loggedIn: false,
          data: null,
          usertype : null
        },
        loading: false,
        userData:'',
        activities:[],
        notifications:[],
        bankDetails:[],
        walletBalance:[],
        username:"",
        securityPin:"",
        setPin:false
      },
      getters: {
        user(state){
          return state.user
        }
    },

    mutations: {
        fetchUserData(state){
        state.loading = true;
        getDoc(doc(db, "users", localStorage.getItem("tippingsKey")))
      .then((response) => {
        state.username = response.data().username
        state.userData = response.data();
        state.activities = response.data().transactions.reverse();
        state.notifications = response.data().notifications.reverse();
        state.subscribers = response.data().subscribers
        state.bankDetails = response.data().bank
        state.securityPin = response.data().securityPin
        state.walletBalance = response
          .data()
          .wallet
      })
      .then(() => {
        state.loading = false;
        if(state.securityPin == 1234){
          state.setPin = true
        }
      });
        },

        SET_LOGGED_IN(state, value) {
          state.user.loggedIn = value;
        },
        SET_USER(state, data) {
          state.user.data = data;
        },
      },

      actions: {
        fetchUserData: (context) => {
          context.commit("fetchUserData");
        },
        fetchUser({ commit }, user) {
          commit("SET_LOGGED_IN", user !== null);
          if (user) {
            commit("SET_USER", {
              uid: user.uid,
              displayName: user.displayName,
              email: user.email,
              photoURL: user.photoURL,
            });
          } else {
            commit("SET_USER", null);
          }
        },
    }

});
